import { cn } from 'lib/utils';

interface IProps {
  message: string;
  isValidation?: boolean;
  className?: string;
  preIcon?: JSX.Element;
  testId?: string;
}

const ErrorMessage = ({
  className,
  message,
  isValidation = false,
  preIcon,
  testId,
}: IProps): JSX.Element => {
  return (
    <div
      data-testid={`error-text${testId ? `-${testId}` : ''}`}
      className={cn(
        isValidation
          ? cn(
              'text-sm leading-5 font-normal text-red-400 mt-1 flex',
              className
            )
          : 'capitalize',
        preIcon &&
          '[&>i]:flex [&>i]:items-center [&>i]:justify-center [&>i]:p-0 [&>i]:pr-1'
      )}
    >
      {preIcon}
      <span>{message}</span>
    </div>
  );
};

export default ErrorMessage;
